import { forwardRef } from 'react';

import {
  ClaimAllButton,
  MilestoneCollection,
  MilestoneCollectionV2,
  MilestoneCollectionProps,
} from '@wwe-portal/ui/features/club-store/milestone';

import { SectionLayout } from './section-layout';

export interface MissionSectionProps {
  title?: string;
  description?: string;
  isClaimAllAble?: boolean;
  onClaim?: () => void;
  data: MilestoneCollectionProps | undefined;
  viewMoreBtn: React.ReactNode;
  claimAllTooltipContent: string;
  isRevamp?: boolean;
  onMissionSectionClick?: (type: number) => void;
}

export const MissionSection = forwardRef<HTMLDivElement, MissionSectionProps>(
  (
    {
      title,
      description,
      data,
      isClaimAllAble,
      onClaim,
      viewMoreBtn,
      claimAllTooltipContent,
      isRevamp,
      onMissionSectionClick,
    },
    ref
  ) => {
    return (
      <SectionLayout
        description={description}
        ref={ref}
        title={
          <div className="relative flex items-center justify-between">
            <div className="text-text300 font-poppins text-base font-[600] md:text-xl">
              {title}
            </div>
            <ClaimAllButton
              isClaimAllAble={isClaimAllAble}
              onClaimAll={onClaim}
              tooltipContent={claimAllTooltipContent}
            />
          </div>
        }
      >
        {isRevamp ? (
          <MilestoneCollectionV2
            {...data}
            onMissionSectionClick={onMissionSectionClick}
          />
        ) : (
          <>
            {data && <MilestoneCollection {...data} />}
            {viewMoreBtn}
          </>
        )}
      </SectionLayout>
    );
  }
);

MissionSection.displayName = 'MissionSection';
